import script from "./SignInPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SignInPage.vue?vue&type=script&setup=true&lang=js"

import "./SignInPage.vue?vue&type=style&index=0&id=05eed6bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05eed6bd"]])

export default __exports__